module.exports = __webpack_public_path__ + "img/sales.dac5258d.svg";